import { ReactElement, useMemo } from "react";
import { ValidGlobalSearchItemPersistedModel } from "../../Persistence/validation";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { TimeZone } from "client/DateAndTime/timezones";
import { SearchListItem } from "client/Features/Search/SearchListItem";
import { generateTrackingId } from "client/Misc/utils";
import { HubItemMediaPreviewViewModel } from "client/Api/Hub/common";
import { useKnowledgeItemNavigationHandler } from "client/Features/Layout/TitleBar/GlobalSearch/Navigation/useKnowledgeItemNavigationHandler";
import { KnowledgeItemListItem } from "client/Features/Hub/KnowledgeItems/ListItem/KnowledgeItemListItem";
import { convertHubMedia } from "../../Persistence/convertPersistedData";

export type KnowledgeItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.KnowledgeItems>;
	navigationIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
};

export const KnowledgeItemView = (props: KnowledgeItemViewProps): ReactElement => {
	const {
		item,
		navigationIndex,
		onRemove,
		timezone
	} = props;

	const {
		id,
		title,
		category,
		author,
		lastModifiedDate,
		media: persistedMedia
	} = item.knowledgeItem;

	const media = useMemo(
		(): HubItemMediaPreviewViewModel => convertHubMedia(persistedMedia),
		[persistedMedia]
	);

	const executeHandler: () => void = useKnowledgeItemNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<SearchListItem
			onExecute={executeHandler}
			trackingId={generateTrackingId("knowledge-item", `|${id}`)}
		>
			<KnowledgeItemListItem
				title={title}
				categoryName={category?.name}
				authorName={author?.name}
				lastModifiedDate={lastModifiedDate}
				media={media}
				trackingId={generateTrackingId("knowledge-item-result-list-item", `|${id}`)}
				timezone={timezone}
				onRemove={onRemove}
				itemIndex={navigationIndex}
				tabIndex={-1}
				onExecute={executeHandler}
			/>
		</SearchListItem>
	);
};
KnowledgeItemView.displayName = "KnowledgeItemView";